import React from "react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { SovosIconButton } from "mosaic-react";
import { Comment } from "mosaic-react-icons";
import ModalHeaderCloseCustom from "../ModalHeaderCloseCustom/HeaderModalCloseButton";

const FindingModalButton = (props) => {
    const {
        projectId,
        fiscalYear,
        importId,
        ruleId,
        modulePrefix,
        origin,
        entityName,
        entityId,
        rowsSelected,
    } = props;
    const findingsList = (rowsSelected || []).map((x) => x.id);

    const { pushModal, reload, i18n } = useGlobalValue();

    const data = {
        projectId,
        fiscalYear,
        importId,
        ruleId,
        findingsList: findingsList && findingsList.length ? findingsList.join(", ") : undefined,
    };

    return (
        <SovosIconButton
            tooltipText={i18n`new audit note`}
            onClick={() => {
                pushModal({
                    title: "Audit notes for Findings",
                    data: { ...data },
                    args: {
                        id: findingsList && findingsList.length === 1 ? findingsList[0] : ruleId,
                        projectId,
                        fiscalYear,
                        importId,
                        modulePrefix,
                        origin: findingsList && findingsList.length ? "F" : origin,
                        entityName,
                        entityId,
                        findingsList: findingsList.join(", "),
                        findingId:
                            findingsList && findingsList.length
                                ? findingsList.length === 1
                                    ? findingsList[0]
                                    : findingsList.join(", ")
                                : ruleId,
                        showAuditNoteHistory:
                            findingsList && findingsList.length > 1 ? false : true,
                    },
                    view: "AuditNotesForm",
                    modalType: "audit",
                    customHeaderButton: ModalHeaderCloseCustom,
                })
                    .then(() => reload && reload())
                    .catch(() => null);
            }}
        >
            <Comment />
        </SovosIconButton>
    );
};

export default FindingModalButton;
